import React from 'react';
import ButtonAction from '../../../buttons/ButtonAction';
import SelectCamera from '../../../../pages/Dashboard/Company/Employees/Modal/SelectCamera';
import Webcam from 'react-webcam';
import { WebcamContainer, WebcamCountContainer, WebcamStyles } from '../../../Styles';
import {IconLoading, CancelIconsOptions, UseCameraIcon} from '../../../buttons/IconButtons';
import CustomModalSuggestions from '../../ModalSuggestions/CustomModalSuggestions';
import WebcamComponentApp from '../../Functionality/WebcamComponentApp';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @param id: component id
 * @param useState setPhotoPicker: state to update the component model
 * @param boolean startup: to start the camera outside the component
 * @param var selectedCamera: variable that holds the selected camera
 * @param useState setSelectedCamera: state to update the camera selection
 * @param useState setStartup: setStartup state to set values when the option to start the camera is used outside the component
 * @param model typeSuggestions: required if showBtnCamera == true, the model must come from SUGGESTION_MODE_OPTION
 * @param boolean validateFace: default value is false, must be set to true if face validation is required
 * @param state setDisplayModal: State management to ensure only one modal is visible at a time.
 * @param state boolean reopenSuggestionShow: hHas a default value of true, and the variable is used to control whether the suggestions modal should be shown each time the photo capture process starts using the standalone camera component — that is, when only the camera functionality is used in an individual component.
 * @param event btnCancelStream :  is an event that is handled when the camera-only functionality is used in a separate component.
 * @param boolean isMultipleFile: Indicates whether multiple files will be uploaded.
 *
 */
const WebcamComponent = (props) => {
    const  {
        id = 'fp_cpp_photo_file',
        selectedCamera,
        setSelectedCamera,
        setStartup,
        typeSuggestions,
        setDisplayModal=null,
        reopenSuggestionShow=true,

        setPhotoPicker,
        startup,
        validateFace,
        btnCancelStream=null,
        isMultipleFile=false
    } = props;

    const {
        webcamRef,
        selectCameraDialogShow,
        setSelectCameraDialogShow,
        selfieSuggestionShow,
        setSelfieSuggestionShow,
        hasAgreedCameraUse,
        countdown,
        capturing,
        cancelSelfie,
        handleStartup,
        getUserMedia
    } = WebcamComponentApp({
        setPhotoPicker:setPhotoPicker,
        startup:startup,
        selectedCamera:selectedCamera,
        setSelectedCamera:setSelectedCamera,
        setStartup:setStartup,
        validateFace: validateFace,
        setDisplayModal:setDisplayModal,
        btnCancelStream:btnCancelStream,
        reopenSuggestionShow:reopenSuggestionShow,
        isMultipleFile:isMultipleFile
    });

    return (<>

        <div className='d-flex flex-column justify-content-center align-items-center w-100'>
            <div className='d-flex flex-column align-items-center gap-3 w-100'>
                { selectedCamera?.deviceId && hasAgreedCameraUse &&
                    <div id={id} className='position-relative d-grid gap-3 w-100'>
                        <>
                            <div style={WebcamContainer(capturing && countdown > 0)} >
                                <Webcam
                                    audio={false}
                                    ref={webcamRef}
                                    screenshotFormat="image/jpeg"
                                    videoConstraints={{
                                        deviceId: selectedCamera.deviceId,
                                    }}
                                    style={WebcamStyles}
                                />

                                {capturing && countdown > 0 && (
                                    <div style={WebcamCountContainer} >
                                        {countdown}
                                    </div>
                                )}
                            </div>
                        </>

                        <div className='d-flex align-items-center gap-3 w-100'>
                            {capturing && countdown ?
                                <>
                                    <ButtonAction
                                        id='btn_wc_take_photo_loading'
                                        name='take_photo'
                                        className='btn-color-shades-200 w-100'
                                        disabled={true}
                                        splitName={false}
                                        Icon={IconLoading}
                                    />
                                </>
                                :
                                <>
                                    <ButtonAction
                                        id='btn_we_cancel'
                                        name={'cancel'}
                                        className='btn-outlined-error-600 w-100'
                                        disabled={false}
                                        splitName={false}
                                        Icon={CancelIconsOptions}
                                        onClick={() => {
                                            cancelSelfie();
                                        }}
                                    />
                                    <ButtonAction
                                        id='btn_wc_take_photo'
                                        name={'take_photo'}
                                        className='btn-icon-upload-file w-100'
                                        disabled={false}
                                        splitName={false}
                                        Icon={UseCameraIcon}
                                        onClick={() => {
                                            handleStartup();
                                        }}
                                    />
                                </>
                            }
                        </div>
                    </div>
                }
            </div>
        </div>

        { selectCameraDialogShow && selectedCamera == null &&
            <SelectCamera
                open={selectCameraDialogShow}
                onClose={() => {
                    setStartup(false)
                    setSelectCameraDialogShow(false);
                }}
                setSelectedCamera={setSelectedCamera}
                setSelectCameraDialogShow={setSelectCameraDialogShow}
                setDisplayModal={setDisplayModal}
            />
        }


        { selfieSuggestionShow && reopenSuggestionShow &&
            <CustomModalSuggestions
                show={selfieSuggestionShow}
                typeSuggestions={typeSuggestions}
                onHide={()=>{
                    setStartup(false);
                    setSelfieSuggestionShow(false);
                    if(setDisplayModal) setDisplayModal("")
                }}
                onConfirm={()=>{
                    setSelfieSuggestionShow(false);
                    getUserMedia();
                    if(setDisplayModal) setDisplayModal("")
                }}
            />
        }

    </>);

}

export default WebcamComponent;
